module.exports = __webpack_public_path__ + "static/media/off_20241221.d11e35e4.png";